import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    invoiceNoContainer: {
        flexDirection: 'row',
        marginTop: 36,
        justifyContent: 'flex-end'
    },
    invoiceDateContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    invoiceDate: {
            fontSize: 12,
            fontStyle: 'bold',
    },
    label: {
        width: 120
    }
    
  });


  const InvoiceNo = ({payment}) => (
        <Fragment>
            <View style={styles.invoiceNoContainer}>
                <Text style={styles.label}>Numéro de facture:</Text>
                <Text style={styles.label}>{payment?.transaction_reference}</Text>
            </View >
            <View style={styles.invoiceDateContainer}>
                <Text style={styles.label}>Date:</Text>
                <Text style={styles.label} >{payment?.createdAt ? new Date(payment.createdAt).toLocaleString() : ''}</Text>
            </View >
        </Fragment>
  );
  
  export default InvoiceNo